import * as React from 'react';
import { MutationFunc } from 'react-apollo';
import { RouteComponentProps, Link, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import { adopt } from 'react-adopt';
import axios from 'axios';
import * as config from '../../config';
import { ApolloClientFactory } from '../../domain/apolloClientFactory';
import GetDeliveryMethodsQuery from '../../components/Query/DeliveryMethods';
import GetPaymentMethodsQuery from '../../components/Query/PaymentMethods';
import FullVariants from '../../components/Query/Products/FullVariants';
import { Button, Container, Icon, Loader, Modal, OrderBox, Section, Tabs, Title } from '../../modules/modules';
import AuthService from '../../services/AuthService';
import CartService from '../../services/CartService';
import { OrderBasketStore } from '../OrderBasket/OrderBasketStore';
import FlashStore from '../../services/FlashStore';
import CartNav from '../../components/CartNav';
import CustomerData from '../../components/CustomerData';
import CustomsWarning from '../../components/CustomsWarning';
import CountryService from '../../services/CountryService';
import { getCountyStateRequired } from '../../helpers/country/getCountyStateRequired';
import { validateEmail } from 'helpers/src/validate/validateEmail';
import NotLogged from '../../components/Header/components/Account/components/NotLogged';
import { vatDescription } from '../../helpers/vatDescription';
import { removeUnavailableItemsFromCart } from '../../helpers/removeUnavailableItemsFromCart';

const USED_VAT_MESSAGE = 'number is used by other account. Please contact support.';

interface IPersonalDataState {
  loaded: boolean;
  ordering: boolean;
  tab?: number;

  // privacy: boolean;
  errors: {
    Firstname: boolean;
    Lastname: boolean;
    Email: boolean;
    Phone: boolean;
    AddressZip: boolean;
    AddressLine1: boolean;
    AddressCity: boolean;
    AddressCountyState: boolean;
    AddressCountry: boolean;
    DeliveryAddressLine1: boolean;
    DeliveryAddressCity: boolean;
    DeliveryAddressZip: boolean;
    DeliveryAddressCountyState: boolean;
    DeliveryAddressCountry: boolean;
    DeliveryPhone: boolean;
  };
  displayVATModal: boolean;
  checkingVat: boolean;
  validationVat: {
    background?: boolean;
    vatNumber?: string;
    countryCode?: string;
    valid: undefined | boolean;
    requestFailed?: boolean;
    result: any;
    validationRequired: boolean | undefined;
    message?: string | null
  };
  redirectToPaymentAndDelivery: boolean;
}

interface IPersonalDataProps extends RouteComponentProps<{ language: string }> {
  data?: any;
  createOrder: MutationFunc;
  createPayment: MutationFunc;
}

interface ICartParams {
  ids: Array<any>;
  currencyId: string;
  render: () => void;
}

const CartParams = adopt({
  deliveryMethods: <GetDeliveryMethodsQuery />,
  paymentMethods: <GetPaymentMethodsQuery />,
  variants: ({ ids, render, currencyId }: ICartParams) => <FullVariants ids={ids} currencyId={currencyId}>{render}</FullVariants>
});

@observer
class PersonalData extends React.Component<IPersonalDataProps, IPersonalDataState> {

  public state: IPersonalDataState;

  private validVatTimer: any;

  public static getDerivedStateFromProps(props: IPersonalDataProps | any, state: IPersonalDataState) {
    if (props.data.userInfo != undefined && !state.loaded) {
      const userInfo = props.data.userInfo as GQL.IUser;

      const customerData = { ...CartService.GetInstance().customerData };

      const { country } = CountryService.GetInstance();

      const customer = {
        Firstname: userInfo.invoiceFirstName,
        Lastname: userInfo.invoiceLastName,
        Email: userInfo.email,
        Phone: userInfo.phone,
        // adresa
        AddressStreet: userInfo.invoiceStreet,
        AddressStreetNumber: userInfo.invoiceHouseNumber,
        AddressLine1: userInfo.invoiceAddressLine1,
        AddressLine2: userInfo.invoiceAddressLine2,
        AddressZip: userInfo.invoiceZip,
        AddressCity: userInfo.invoiceCity,
        AddressCountyState: userInfo.invoiceCountyState,
        // jiná doručovací adresa
        AnotherDeliveryAddress: userInfo.anotherDeliveryAddress,
        // doručovací adresa
        DeliveryFirstName: userInfo.invoiceFirstName,
        DeliveryLastName: userInfo.invoiceLastName,
        DeliveryPhone: userInfo.deliveryPhone,
        DeliveryAddressStreet: userInfo.deliveryStreet,
        DeliveryAddressStreetNumber: userInfo.deliveryHouseNumber,
        DeliveryAddressLine1: userInfo.deliveryAddressLine1,
        DeliveryAddressLine2: userInfo.deliveryAddressLine2,
        DeliveryAddressZip: userInfo.deliveryZip,
        DeliveryAddressCity: userInfo.deliveryCity,
        DeliveryAddressCountyState: userInfo.deliveryCountyState,
        // odběr novinek
        Newsletter: userInfo.receiveNewsletter,
        // nákup na firmu
        CompanyInformation: userInfo.companyInformation,
        Company: userInfo.companyName,
        CompanyRegistrationNumber: userInfo.companyRegistrationNumber,
        CompanyVatNumber: userInfo.companyVatNumber,
        // země dle vybrané
        AddressCountry: userInfo.invoiceCountry,
        DeliveryAddressCountry: userInfo.deliveryCountry,
        // země dle vybrané
        _AddressCountry: { ...country },
        _DeliveryAddressCountry: { ...country },
        // původní data zákazníka
        ...customerData,
      };

      // setting default data and overrides it by cart data
      CartService.GetInstance().setCustomerData(customer);

      const newState = {
        ...state,
        loaded: true
      };

      return newState;
    }

    return state;
  }

  constructor(props: any) {
    super(props);
    CartService.GetInstance().validateBasketStatus();

    this.handleSend = this.handleSend.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeCustomerData = this.onChangeCustomerData.bind(this);

    this.state = {
      loaded: false,
      ordering: false,
      displayVATModal: false,
      errors: {
        Firstname: false,
        Lastname: false,
        Email: false,
        Phone: false,
        // fakturační adresa
        AddressLine1: false,
        AddressZip: false,
        AddressCity: false,
        AddressCountyState: false,
        AddressCountry: false,
        //  při jiné adrese
        DeliveryAddressLine1: false,
        DeliveryAddressCity: false,
        DeliveryAddressZip: false,
        DeliveryAddressCountyState: false,
        DeliveryAddressCountry: false,
        DeliveryPhone: false,
      },
      checkingVat: false,
      validationVat: {
        background: false,
        vatNumber: undefined,
        countryCode: undefined,
        valid: undefined,
        requestFailed: false,
        result: null,
        validationRequired: undefined,
      },
      redirectToPaymentAndDelivery: false,
    };
  }

  private isValid() {
    const store = CartService.GetInstance();
    const errors = { ...this.state.errors };

    const { data: { countries } } = this.props;
    const customer = store.customerData as any;
    const invoiceCountry = customer.AddressCountry;
    const deliveryCountry = customer.DeliveryAddressCountry;
    // tslint:disable-next-line:no-string-literal
    const hasAnotherDeliveryAddress = customer['AnotherDeliveryAddress'];

    const wrongInvoicingCountry = !countries.find((c: GQL.ICountry) => c.name === invoiceCountry);
    if (wrongInvoicingCountry) {
      customer.AddressCountry = '';
      FlashStore.GetInstance().showMessage('Check your invoicing address', 'error');
    }

    const wrongDeliveryCountry = deliveryCountry ? !countries.find((c: GQL.ICountry) => c.name === deliveryCountry) : false;
    if (wrongDeliveryCountry) {
      customer.DeliveryAddressCountry = '';
      FlashStore.GetInstance().showMessage('Check your delivery country.', 'error', 4000);
    }

    /* tslint:disable:no-string-literal */
    const valid = Object.keys(this.state.errors).reduce((prev: boolean, next: string) => {
      errors[next] = false;
      if (next === 'Email') {
        if (!validateEmail(store.customerData[next])) {
          errors[next] = true;
          prev = false;
        }

      } else if (next === 'DeliveryAddressCountyState' && hasAnotherDeliveryAddress) {
        const isDeliveryStateRequired = getCountyStateRequired(store.customerData['_DeliveryAddressCountry']) && !store.customerData[next];
        if (isDeliveryStateRequired) {
          errors[next] = true;
          prev = false;
        }
      } else if (next === 'AddressCountyState') {
        const isBillingStateRequired = getCountyStateRequired(store.customerData['_AddressCountry']) && !store.customerData[next];
        if (isBillingStateRequired) {
          errors[next] = true;
          prev = false;
        }
      } else if (next.substr(0, 15) === 'DeliveryAddress') {
        if (hasAnotherDeliveryAddress) {
          if (!store.customerData[next]) {
            errors[next] = true;
            prev = false;
          }
        }
      } else if (next === 'DeliveryPhone') {
        if (hasAnotherDeliveryAddress) {
          if (!store.customerData[next]) {
            errors[next] = true;
            prev = false;
          }
        }
      } else if (!store.customerData[next]) { // Tohle kontroluje "required", ale pole musí být definováno v this.state.errors, jinak nekontroluje
        errors[next] = true;
        prev = false;
      }
      return prev;
    }, true);
    /* tslint:enable:no-string-literal */

    this.setState({
      errors,
    });

    const areCountriesWithinAllowedRegions = CountryService.GetInstance().areCountriesWithinAllowedRegions(countries, invoiceCountry, deliveryCountry);
    if (!areCountriesWithinAllowedRegions && hasAnotherDeliveryAddress) {
      // tslint:disable-next-line:no-string-literal
      errors['DeliveryAddressCountry'] = true;
      // reset delivery country then and continue
      CartService.GetInstance().updateCustomerData({ 'DeliveryCountry': '', _DeliveryAddressCountry: null, _DeliveryAddressCountrySelectedByCustomer: null });
      FlashStore.GetInstance().showMessage('We are not shipping outside EU for EU invoicing addresses and opposite way. Choose other delivery country.', 'error');
      return false;
    }

    return valid;
  }

  private isValidVat = async () => {
    const customerData = { ...CartService.GetInstance().customerData } as any;

    // země
    const { countryCode } = CountryService.GetInstance();
    const { Email, CompanyInformation, CompanyVatNumber, AddressCountry } = customerData;

    // DIČ
    /* tslint:disable:no-string-literal */
    const vatNumber = CompanyInformation && CompanyVatNumber
      ? CompanyVatNumber.trim()
      : undefined;
    /* tslint:enable:no-string-literal */

    if (!vatNumber || vatNumber.length === 0) {
      this.setState({
        validationVat: {
          ...this.state.validationVat,
          validationRequired: false,
        }
      });

      return;
    }

    // šasovač se vynuluje
    if (this.validVatTimer) {
      clearTimeout(this.validVatTimer);
    }

    this.setState({
      checkingVat: true,
    }, () => {
      // časovač
      this.validVatTimer = setTimeout(async () => {
        // došlo k nějaké relevantní změně
        if (customerData &&
          (this.state.validationVat.vatNumber !== vatNumber
            || this.state.validationVat.countryCode !== countryCode
            || this.state.validationVat.background === true)) {
          // naposledy kontrolované DIČ
          await this.setState({
            validationVat: {
              ...this.state.validationVat,
              vatNumber,
              countryCode,
            }
          });

          // nastavení pro objednávku
          await CartService.GetInstance().updateCustomerData({
            CompanyVatNumberValid: false,
          });

          // validace DIČ
          axios({
            method: 'POST',
            url: config.url + '/orders/vat-validator',
            headers: {
              'Content-Type': 'application/json',
            },
            data: {
              email: Email,
              country: AddressCountry,
              vatNumber,
            }
          })
            .then(async (result) => {
              // výsledek
              const resultData = result && result.data ? result.data : {};
              // poslední kontrolavé DIČ
              this.setState({
                checkingVat: false,
                validationVat: {
                  vatNumber,
                  countryCode,
                  background: resultData.background === true,
                  message: resultData.message,
                  valid: vatNumber && resultData.error !== true
                    ? resultData.valid === true
                    : undefined,
                  requestFailed: resultData.error === true,
                  result: resultData,
                  validationRequired: resultData.validationRequired !== false,
                }
              });

              // if validation errored and there is flag that it's running in background, schedule another check
              // timeout is set to 5 seconds, but it can be changed based on expected time of validation and user experience
              if (resultData.background === true) {
                clearTimeout(this.validVatTimer);
                setTimeout(this.isValidVat, 5000);
              }

              // nastavení pro objednávku
              await CartService.GetInstance().updateCustomerData({
                CompanyVatNumberValid: resultData.valid === true,
              });

              // nastavení jména společnosti
              if (resultData.valid === true && resultData.name) {
                await CartService.GetInstance().updateCustomerData({
                  Company: resultData.name,
                });
              }
            })
            .catch((error) => {
              console.error('validation vat error', error);
            });

        } else {
          this.setState({
            checkingVat: false,
          });
        }

      }, 1000);
    });
  }

  public async componentDidMount() {
    if (!AuthService.GetInstance().loggedIn) {
      this.isValidVat();
    }
  }

  public async componentDidUpdate(prevProps: IPersonalDataProps, prevState: IPersonalDataState) {
    if (this.state.loaded !== prevState.loaded) {
      this.isValidVat();
    }
  }

  private goToPaymentAndShipping = (skipVATCheck: boolean = false) => {
    const { validationVat } = this.state;
    const cartService = CartService.GetInstance();
    const customer = cartService.customerData as any;

    if (false === cartService.doCountryCurrenciesMatch()) {
      return;
    }

    if (!skipVATCheck
      && customer.AddressCountry !== 'Czech Republic'
      && customer.CompanyInformation === true
      && customer.CompanyVatNumber
      && validationVat.validationRequired && (!validationVat.valid || validationVat.requestFailed)) {
      this.setState({ displayVATModal: true });
      return;
    }

    const valid = this.isValid();

    if (valid || skipVATCheck) {

      if (this.state.validationVat.result &&
        this.state.validationVat.result.message === USED_VAT_MESSAGE) {
        cartService.setCustomerData({ ...customer, CompanyVatNumber: null });
      }

      // Country code urls are not used anymore
      // this.props.history.push(`/${countryCode}/payment-and-shipping`);
      this.props.history.push('/payment-and-shipping');
    }

  }

  public async handleSend(paymentMethods: Array<GQL.IPaymentMethod>, deliveryMethods: Array<GQL.IDeliveryMethod>) {
    const countryCode = CountryService.GetInstance().countryCode;
    const language = CountryService.GetInstance().language;
    const currency = CountryService.GetInstance().currency;
    const currencyId = currency ? currency.id : null;
    const countryId = CountryService.GetInstance().country.id;
    const valid = this.isValid();

    const status = await CartService.GetInstance().validateBasketStatus();
    if (!status) {
      return;
    }

    // const validators = this.formValidators;
    const store = CartService.GetInstance();

    const paymentId = store.paymentId;
    const deliveryId = store.deliveryId;
    const deliveryInsuranceLimit = store.deliveryInsuranceLimit;

    if (!valid || !paymentId || !deliveryId || !currencyId || !status) {
      // FlashStore.GetInstance().showMessage('Prosíme, doplňte chybějící údaje.', 'error', 4000);
      return;
    }

    // vybraný způsob platby
    const paymentMethod = paymentMethods.find((p: GQL.IPaymentMethod) => p.id === paymentId);
    // vybraný způsob dopravy
    const deliveryMethod = deliveryMethods.find((d: GQL.IDeliveryMethod) => d.id === deliveryId);

    if (!paymentMethod || !deliveryMethod) {
      return;
    }

    const values = store.customerData as any;

    if (!this.state.ordering) {
      this.setState({ ordering: true }, async () => {
        const orderData = {
          countryId,
          deliveryMethodId: deliveryMethod.id,
          paymentMethodId: paymentMethod.id,
          deliveryInsurance: deliveryInsuranceLimit !== null,
          currencyId,
          email: values.Email,
          phone: values.Phone,
          voucherIds: CartService.GetInstance().voucherIds,
          // firma
          companyInformation: values.CompanyInformation,
          companyName: values.CompanyInformation === true ? values.Company : null,
          companyRegistrationNumber: values.CompanyInformation === true ? values.CompanyRegistrationNumber : null,
          companyVatNumber: values.CompanyInformation === true ? values.CompanyVatNumber : null,
          companyVatNumberValid: values.CompanyInformation === true ? values.CompanyVatNumberValid : false,
          // lokalizace
          language,
          invoiceFirstName: values.Firstname,
          invoiceLastName: values.Lastname,
          invoiceStreet: values.AddressStreet,
          invoiceHouseNumber: values.AddressStreetNumber,
          invoiceAddressLine1: values.AddressLine1,
          invoiceAddressLine2: values.AddressLine2,
          invoiceZip: values.AddressZip,
          invoiceCity: values.AddressCity,
          invoiceCountyState: values.AddressCountyState,
          invoiceCountry: values.AddressCountry,
          // doručovací adresa
          anotherDeliveryAddress: values.AnotherDeliveryAddress,
          deliveryFirstName: values.AnotherDeliveryAddress === true ? values.DeliveryFirstName : values.FirstName,
          deliveryLastName: values.AnotherDeliveryAddress === true ? values.DeliveryLastName : values.LastName,
          deliveryStreet: values.AnotherDeliveryAddress === true ? values.DeliveryAddressStreet : values.AddressStreet,
          deliveryHouseNumber: values.AnotherDeliveryAddress === true ? values.DeliveryAddressStreetNumber : values.AddressStreetNumber,
          deliveryAddressLine1: values.AnotherDeliveryAddress === true ? values.DeliveryAddressLine1 : values.AddressLine1,
          deliveryAddressLine2: values.AnotherDeliveryAddress === true ? values.DeliveryAddressLine2 : values.AddressLine2,
          deliveryZip: values.AnotherDeliveryAddress === true ? values.DeliveryAddressZip : values.AddressZip,
          deliveryCity: values.AnotherDeliveryAddress === true ? values.DeliveryAddressCity : values.AddressCity,
          deliveryCountyState: values.AnotherDeliveryAddress === true ? values.DeliveryAddressCountyState : values.AddressCountyState,
          deliveryCountry: values.DeliveryAddressCity
            ? (values.AnotherDeliveryAddress === true ? values.DeliveryAddressCountry : values.AddressCountry)
            : values.AddressCountry,
          // poznámky
          notes: values.Notes,
          // položky
          items: CartService.GetInstance().orderItems.map(o => {
            return {
              variantId: o.variant.id,
              quantity: o.quantity
            };
          })
        };

        const result = await this.props.createOrder({
          variables: {
            order: orderData,
          }
        });

        if (
          Array.isArray(result.data.createOrder.maxAvailableStock) &&
          result.data.createOrder.maxAvailableStock.length > 0
        ) {
          this.setState({ ordering: false });
          ApolloClientFactory.GetClient().resetStore();
          this.props.history.push(`/${countryCode}/cart`);
        } else {
          CartService.GetInstance().removeEverything();
          OrderBasketStore.ResetInstance();

          const { order } = result.data.createOrder;
          const { email, orderNumber } = order;

          this.setState({ ordering: false });

          // platba online
          if (paymentMethod.gateway) {
            this.sendGoogleEcommerce(language, order)
              .then(() => {
                // přesměr na stránku s potvrzením objednávky
                this.props.history.push(`/${countryCode}/order-finished/${orderNumber}/${order.id}`);
              });
          } else {
            this.sendGoogleEcommerce(language, order)
              .then(() => {
                this.props.history.push(`/${countryCode}/order-finished/${orderNumber}/${order.id}`, {
                  orderNumber,
                  email
                });
              });
          }
        }
      });
    }
  }

  public render() {
    const { countryCode } = CountryService.GetInstance();
    const { displayVATModal, validationVat } = this.state;
    const currency = CountryService.GetInstance().currency;

    if (CartService.GetInstance().getAllVariantIds().length === 0) {
      this.props.history.push(`/${countryCode}/cart`);
      return null;
    }

    if (this.state.redirectToPaymentAndDelivery) {
      return (
        <Redirect to={'/payment-and-shipping'} />
      );
    }

    const { data: { userInfo } } = this.props;

    return (
      <main>
        <CartParams
          ids={CartService.GetInstance().getAllVariantIds()}
          currencyId={currency.id}
        >
          {({ paymentMethods, deliveryMethods, variants }: any) => {
            if (
              paymentMethods.paymentMethods.loading ||
              deliveryMethods.deliveryMethods.loading ||
              variants.fullVariants.loading
            ) {
              return <Loader />;
            }

            removeUnavailableItemsFromCart(variants, currency);

            // rekalkulace cen pro případ že se změnila měna
            // const cartContent = CartService.GetInstance().getAllVariantIds().map(variantId => {
            //     const quantity = CartService.GetInstance().getQuantityForVariant(variantId);
            //     const itemPrice = findPrice(variants.find((variant: any) => {
            //         return variant.id === variantId;
            //     }).prices);
            //     const recommendedItemPrice = itemPrice;
            //     return {
            //         variant, quantity, itemPrice, recommendedItemPrice
            //     };
            // });
            // for (const item of cartContent) {
            //     CartService.GetInstance().removeItemCompletelyFromCart(item.variantId);
            //     CartService.GetInstance().addToCart(item.variant, item.recommendedItemPrice);
            // }

            // dostupná seznamy seznamů plateb a dopravy
            // const paymentMethodsList = paymentMethods.paymentMethods.paymentMethods;
            // const deliveryMethodsList = deliveryMethods.deliveryMethods.deliveryMethods;

            // varianty
            const eans = variants.fullVariants.variants;
            const hideVATModal = () => this.setState({ displayVATModal: false });
            const customer = (CartService.GetInstance().customerData as any);

            const isCompanyLocked = (userInfo && !!userInfo.companyVatValidationDate)
              && (!!customer.CompanyInformation && !!customer.CompanyVatNumber
                && !!customer.Company && !!customer.AddressCountry);

            return (
              <Section type="personal-data">
                {(validationVat.requestFailed === true
                  || validationVat.valid === false) && validationVat.validationRequired && displayVATModal &&
                  <Modal type={'general'} open={true} onClose={hideVATModal}>
                    <div className={''}>
                      <div className="modal__head">
                        <Icon type={'error'} />
                        <div className="modal__title">
                          VAT NUMBER NOT VERIFIED! VAT IS INCLUDED!
                        </div>
                        <button className="modal__close" onClick={hideVATModal} />
                      </div>
                      <div className="modal__body">
                        {validationVat.message !== USED_VAT_MESSAGE && <div className="modal__main" style={{ padding: '30px 20px', textAlign: 'left' }}>
                          <b>{vatDescription()} IS included.</b> We were unable to verify your {vatDescription()} number. <br />
                          Please try again later as the verification system may be occupied.
                          <br /><br />
                          {validationVat.requestFailed
                            && <span className="vatNumber vatNumber__failed">
                              <b>Your request for {vatDescription()} validation has not been processed:</b><br />
                              the maximum number of concurrent requests for this Member State has been reached.
                              Try to finish the order later, please.
                            </span> || ''}
                        </div> || ''}
                        {validationVat.message === USED_VAT_MESSAGE &&
                          <div className="modal__main" style={{ padding: '30px 20px', textAlign: 'left' }}>
                            <b>{vatDescription()} IS included.</b><br /> We cannot use this {vatDescription()} number
                            because it is already associated with another account.
                            <br /><br />
                            <span className="vatNumber vatNumber__failed">
                              If you would like to use it, please contact support.
                            </span>
                          </div>
                          || ''}
                      </div>
                    </div>
                    <div className="modal__footer">
                      <Button onClick={() => { this.isValidVat(); hideVATModal(); }} type="return" style={{ marginTop: 0 }}>
                        Try again
                      </Button>
                      <Button onClick={() => this.goToPaymentAndShipping(true)} type="proceed" style={{ marginTop: 0 }}>
                        Continue with {vatDescription()}
                      </Button>
                    </div>
                  </Modal>}
                <Container>
                  <div className="cart">
                    <CartNav step={2} />

                    <div className="row">
                      <div className="col-md-12">
                        <Title><h2>Personal details</h2></Title>
                      </div>
                    </div>

                    {!this.state.loaded && AuthService.GetInstance().loggedIn &&
                      <Loader />}

                    <div className="order">

                      {this.state.ordering &&
                        <Loader />}

                      <div className="row">
                        <div className="col-sm-12 col-md-7">

                          {!AuthService.GetInstance().loggedIn && (
                            <Tabs
                              tabs={['I dont have account', 'Log in']}
                              onChange={(tab: number) => {
                                this.setState({ tab });
                              }}
                            >
                              <div className="tab__item">
                                <div className="form form--registration">
                                  <div className="form__section">
                                    <CustomerData
                                      isCompanyLocked={isCompanyLocked}
                                      data={CartService.GetInstance().customerData}
                                      checkingVat={this.state.checkingVat}
                                      validationVat={this.state.validationVat}
                                      errors={this.state.errors}
                                      onChange={this.onChangeCustomerData}
                                      isValidVat={this.isValidVat}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="tab__item">
                                <NotLogged
                                  type={'button'}
                                  refetch={() => {
                                    (this.props as any).data.refetch();
                                    this.isValidVat();
                                  }}
                                  click={this.state.tab === 1}
                                />
                              </div>
                            </Tabs>
                          )}

                          {AuthService.GetInstance().loggedIn && (
                            <Tabs
                              tabs={['Logged user']}
                            >
                              <div className="tab__item">
                                <div className="form form--registration">
                                  <div className="form__section">
                                    <CustomerData
                                      isCompanyLocked={isCompanyLocked}
                                      data={CartService.GetInstance().customerData}
                                      checkingVat={this.state.checkingVat}
                                      validationVat={this.state.validationVat}
                                      errors={this.state.errors}
                                      onChange={this.onChangeCustomerData}
                                      isValidVat={this.isValidVat}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Tabs>
                          )}
                        </div>
                        <div className="col-sm-12 col-md-5">
                          <OrderBox
                            title="Summary"
                            products={(eans || []).map((variant: any) => {
                              return {
                                variant,
                                quantity: CartService.GetInstance().getQuantityForVariant(
                                  variant.id
                                ),
                              };
                            })}
                            price={CartService.GetInstance().prices}
                            payment={CartService.GetInstance().payment}
                            delivery={CartService.GetInstance().delivery}
                          />
                          <CustomsWarning />
                          <div className="nav-buttons nav-buttons--spaced">
                            <Link to={`/${countryCode}/cart`} className="btn btn--return btn--fullMd">
                              Back
                            </Link>
                            <Button onClick={() => this.goToPaymentAndShipping(false)} type="proceed btn--fullMd">
                              Payment and shipping
                            </Button>

                            {/* <Button
                              type="proceed"
                              disabled={this.state.validationVat.requestFailed === true || this.state.checkingVat === true}
                              className="fullMd"
                              onClick={() =>
                                this.handleSend(
                                  paymentMethodsList,
                                  deliveryMethodsList
                                )
                              }
                            >
                              Proceed to checkout
                            </Button> */}
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>
                </Container>
              </Section>
            );
          }}
        </CartParams>
      </main>
    );
  }

  private async onChangeCustomerData(e: any) {
    const { name, value } = e.target;
    // const customerData = CartService.GetInstance().customerData;
    // store previous value to be able revert it
    // const previousValue = customerData[name];

    await CartService.GetInstance().updateCustomerData({ [name]: value });

    // změna země
    if (name === 'AddressCountry' || name === 'DeliveryAddressCountry' || 'AnotherDeliveryAddress' === name) {
      const { data: { countries } } = this.props;
      const country = Array.isArray(countries)
        ? this.props.data.countries.filter((c: GQL.ICountry) => !!c.code).find((c: GQL.ICountry) => c.name === value)
        : null;

      if (name === 'AddressCountry' && country) {
        CartService.GetInstance().updateCustomerData({
          _AddressCountry: country,
          _InvoiceAddressCountrySelectedByCustomer: country,
          AddressCountyState: '',

          // When invoice country is changed, reset delivery address & delivery address state
          // There is issue that country is still selected
          DeliveryAddressCountry: '',
          _DeliveryAddressCountry: '',
          _DeliveryAddressCountrySelectedByCustomer: '',
          DeliveryAddressCountyState: '',
        });

        CountryService.GetInstance().setCountry(country, true, this.props.data.countries);
        // Country code urls are not used anymore, so no need to push new url
        // history.pushState(null, '', `/${country.code}/personal-data`);
      }

      if (name === 'DeliveryAddressCountry' && country) {
        // compare if regions are in EU or outside
        const countryServices = CountryService.GetInstance();
        const customer = CartService.GetInstance().customerData as any;

        const invoiceCountry = customer.AddressCountry;
        const deliveryCountry = customer.DeliveryAddressCountry;

        // when both countries are in the list of countries, check if they are in the same region 
        if (countryServices.areCountriesWithinAllowedRegions(countries, invoiceCountry, deliveryCountry)) {
          // commit information when countries matching EU or non-Eu region
          CartService.GetInstance().updateCustomerData({
            [name]: value,
            _DeliveryAddressCountry: country,
            _DeliveryAddressCountrySelectedByCustomer: country,
            DeliveryAddressCountyState: '',

          });
        } else {
          if (invoiceCountry) {
            // revert country when counties not matching EU or outside EU
            CartService.GetInstance().updateCustomerData({ [name]: undefined, _DeliveryAddressCountry: null, _DeliveryAddressCountrySelectedByCustomer: null });
            // send message to customer about it
            FlashStore
              .GetInstance()
              .showMessage('Shipping not available for this country or store region. Change your delivery country or switch the store in the top-right corner.', 'error');
          }
        }
      }
    }

    // změna DIČa a jiného závislého údaje
    if (
      name === 'CompanyVatNumber'
      || name === 'AddressCountry'
      || name === 'AnotherDeliveryAddress'
      // || name === 'DeliveryAddressCountry'
      || name === 'CompanyInformation'
    ) {
      this.isValidVat();
    }
  }

  private onChange(e: any) {
    const value = e.target.checked !== undefined
      ? e.target.checked
      : e.target.value;

    this.setState({
      ...this.state, [e.target.name]: value
    });
  }

  /**
   * Odeslání objednávky do Google Tag Manageru
   *
   * @param {string} language
   * @param order
   * @returns {Promise<any>}
   */
  private sendGoogleEcommerce(language: string, order: any) {
    return new Promise((resolve, reject) => {
      const country = JSON.parse(localStorage.getItem('country') || '') as any;
      const currencyCode = country && country.details && country.details.currency;
      const dataLayer = (window as any).dataLayer;
      if (dataLayer && currencyCode) {
        const products: any[] = [];
        if (order && order.orderedItems) {
          order.orderedItems.forEach((item: any) => {
            products.push({
              id: item.ean,
              sku: item.sku,
              name: `${(item.name[language] ? item.name[language] : item.name.cs)}`,
              price: item.price,
              quantity: item.quantity,
            });
          });
        }

        const data = {
          event: 'Purchase',
          ecommerce: {
            currencyCode,
            purchase: {
              actionField: {
                id: order.orderNumber,
                revenue: order.grandTotal,
                shipping: order.deliveryTotal,
              },
              products
            }
          }
        };

        dataLayer.push(data);
      }

      resolve(null);
    });
  }
}

export default PersonalData;



// WEBPACK FOOTER //
// ./src/pages/PersonalData/PersonalData.tsx